import {
  Component,
  ContentChild,
  forwardRef,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { FormControlName, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'pr-input-column',
    templateUrl: './pr-input-column.component.html',
    styleUrls: ['./pr-input-column.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PrInputColumnComponent),
            multi: true,
        },
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PrInputColumnComponent implements OnInit {
  @ContentChild(FormControlName, { static: false }) control: FormControlName;

  @Input() derrors: boolean = false;
  @Input() required: boolean = false;

  @Input() label: string;
  @Input() suffix: string;
  @Input() isDefault = true;
  @Input() readonly = false;

  errors: Array<any> = ['This field is required'];

  constructor() {
    if (!this.isDefault) {
      this.isDefault = false;
    }
  }

  ngOnInit() {}

  labelFinishWithSpace(): boolean {
    return this.label && this.label.slice(-1) == ' ';
  }
}
